module.exports = ".file-item {\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.close-button {\r\n\tfloat: right;\r\n    margin-top: -12px;\r\n    margin-right: -12px;\r\n    color: #000000dd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content/upload/upload.component.css
// module id = ./src/app/components/content/upload/upload.component.css
// module chunks = main